export default "__VITE_ASSET__xYUmpEt8__"